<template>
  <div class="activity-description-markdown-styles">
    <slot />
  </div>
</template>

<style scoped lang="scss">
.activity-description-markdown-styles {
  @include font-body-m-light;
  color: var(--color-neutral-70);
  margin: var(--spacing-12) 0;
  @include for-less-or-equal-than-900-px {
    @include font-body-s-light;
  }

  :deep(h3) {
    @include font-button-large;
    color: var(--color-neutral-70);
    margin-top: var(--spacing-24);
    margin-bottom: var(--spacing-8);
  }

  :deep(p) {
    @include font-body-m-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-s-light;
    }
  }
  :deep(p strong) {
    @include font-body-l-bold;
    color: var(--color-neutral-70);
    margin: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-m-bold;
    }
  }

  :deep(div) {
    @include font-body-m-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-s-light;
    }
  }

  :deep(ul) {
    padding-left: var(--spacing-16);
    margin: var(--spacing-24) 0;
  }

  :deep(li) {
    @include font-body-m-light;
    color: var(--color-neutral-70);
    margin: var(--spacing-12) 0;
    @include for-less-or-equal-than-900-px {
      @include font-body-s-light;
    }
  }
}
</style>
